import { useErrorHandling } from './useErrorHandling';
import { useModalConfirm } from './useModalConfirm';
export function useServiceCall(callback) {
  let onFinally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let overrideHttpStatusErrorHandlers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let modalConfirm = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  const errorHandledCall = useErrorHandling(callback, onFinally, onError, overrideHttpStatusErrorHandlers);
  const modalConfirmedCall = useModalConfirm(modalConfirm ? {
    ...modalConfirm,
    onConfirm: callback
  } : null, onFinally, onError);
  return modalConfirm ? modalConfirmedCall : errorHandledCall;
}